import { WorkflowContext } from '@samelogic/steps';
import { TriggerEventProps } from '../../../../models';

export interface OnEventTriggeredEvent<TProps extends TriggerEventProps, TEventData> {
  /**
   * Used to determine if the event condition is still valid.
   */
  condition: boolean;
  /**
   * The props used to setup the trigger
   */
  props: TProps;
  /**
   * Event specific data such as `Event` from the DOM
   */
  data: TEventData;
}
/**
 * Event that fires when event criteria is met.
 * condition is true if the condition options are true.
 */
export type OnEventTriggered<TProps extends TriggerEventProps, TEventData> = (
  event: OnEventTriggeredEvent<TProps, TEventData>
) => void;

export abstract class EventStrategy<TProps extends TriggerEventProps, TEventData> {
  public onEventTriggered?: OnEventTriggered<TProps, TEventData>;
  constructor(protected context: WorkflowContext, protected readonly props: TProps) {}
  public abstract start(): void;
}
